export enum Errors {
  CommerceToolsClientNotInitialized = "CT client not initialized",
  LoginError = "Invalid response: 401"
}
